// src/pages/GroupPage.jsx
import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'

const fmt = (n) => Number(n || 0).toLocaleString('no-NO')

export default function GroupPage() {
  const { id } = useParams()
  const [group, setGroup] = useState(null)
  const [products, setProducts] = useState([])
  const [error, setError] = useState('')

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/product-groups/${id}`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(setGroup)
      .catch(() => setError('Fant ikke kategorien.'))

    fetch(`${process.env.REACT_APP_API_URL}/products`)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(allProducts => {
        setProducts(
  allProducts.filter(
    p =>
      String(p.ProductGroupId) === String(id) &&
      p.is_active !== false &&
      p.is_active !== 0 &&
      p.is_active !== '0' &&
      p.is_active !== 'false'
  )
)
      })
      .catch(() => setProducts([]))
  }, [id])

  if (error) return (
    <div className="text-center mt-6">
      <p className="text-red-500">{error}</p>
      <Link to="/" className="text-blue-600 hover:underline">Tilbake</Link>
    </div>
  )
  if (!group) return <p className="text-center mt-6">Laster…</p>

  function pricingBlock(prod) {
    const saleEnabled = !!prod.is_for_sale && prod.price_sale != null

    const p4h   = prod.price_short_4h != null ? Number(prod.price_short_4h) : null
    const pDay  = prod.price_day      != null ? Number(prod.price_day)      : null
    const pWend = prod.price_weekend  != null ? Number(prod.price_weekend)  : null
    const rentalPrices = [p4h, pDay, pWend].filter(v => v != null)
    const hasRental = rentalPrices.length > 0
    const minRental = hasRental ? Math.min(...rentalPrices) : null

    // Bare kjøp
    if (saleEnabled && !hasRental) {
      return <div className="text-[#000099] font-bold">Per stk: {fmt(prod.price_sale)} kr</div>
    }

    // Bare leie
    if (!saleEnabled && hasRental) {
      return <div className="text-[#000099] font-bold">Fra {fmt(minRental)} kr</div>
    }

    // Både leie og kjøp
    if (saleEnabled && hasRental) {
      return (
        <div className="space-y-0.5">
          <div className="text-[#000099] font-bold">Leie fra {fmt(minRental)} kr</div>
          <div className="text-gray-600 text-sm">Per stk: {fmt(prod.price_sale)} kr</div>
        </div>
      )
    }

    // Ingen prisdata
    return <div className="text-gray-500">Pris etter avtale</div>
  }

  return (
    <div className="max-w-screen-md mx-auto p-6 text-center">
      <Link to="/" className="text-blue-600 hover:underline mb-4 inline-block">
        ← Tilbake til kategorier
      </Link>
      <h1 className="text-3xl font-bold text-[#000099] mb-2">{group.name}</h1>
      <p className="mb-8 text-gray-600">{group.description}</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {products.length > 0 ? (
          products.map(prod => (
            <Link key={prod.id} to={`/product/${prod.id}`}>
              <div className="border rounded-lg shadow-sm hover:shadow-lg p-4 text-left">
                {prod.image_url && (
                  <img
                    src={prod.image_url}
                    alt={prod.name}
                    className="h-40 w-full object-cover rounded mb-2"
                  />
                )}
                <h3 className="font-semibold mb-1">{prod.name}</h3>
                {pricingBlock(prod)}
              </div>
            </Link>
          ))
        ) : (
          <div className="col-span-full text-center text-gray-500">
            Ingen produkter funnet…
          </div>
        )}
      </div>
    </div>
  )
}
